class KvhxKode {
	husnummer: string = "";
	kommuneKode: string = "";
	sal: string = "";
	side: string = "";
	vejkode: string = "";
	constructor(
		husnummer: string = "",
		kommuneKode: string = "",
		sal: string = "",
		side: string = "",
		cpr: string = "",
		vejkode: string = ""
	) {
		this.husnummer = husnummer ?? "";
		this.kommuneKode = kommuneKode ?? "";
		this.sal = sal ?? "";
		this.side = side ?? "";
		this.vejkode = vejkode ?? "";
	}
}
class Postnr {
	postDistrikt: string = "";
	postnr: string = "";
	constructor(postDistrikt: string = "", postnr: string = "") {
		this.postDistrikt = postDistrikt ?? "";
		this.postnr = postnr ?? "";
	}
}
class AddressModel {
	kvhxKode!: KvhxKode;
	postnr!: Postnr;
	supplerendebynavn!: string;
	vejnavn!: string;
}
export const toDatahubAddress = (
	addressRequest: AddressRequest,
	codes?: { kommunekode: string | null; vejkode: string | null }
): AddressModel => {
	let address = new AddressModel();
	address.kvhxKode = new KvhxKode(
		addressRequest.houseNumber,
		codes?.kommunekode ?? "",
		addressRequest.floor,
		addressRequest.door,
		"",
		codes?.vejkode ?? ""
	);
	address.postnr = new Postnr(addressRequest.city, addressRequest.postCode);
	address.vejnavn = addressRequest.street;
	address.supplerendebynavn = "";
	return address;
};

export class AddressRequest {
	street: string = "";
	houseNumber: string = "";
	floor: string = "";
	door: string = "";
	postCode: string = "";
	city: string = "";
}

export default AddressModel;
